module.exports = __webpack_public_path__ + "static/img/data-bg.f7176dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daping/data-bg.png
// module id = 2uUJ
// module chunks = 0